module.exports = __webpack_public_path__ + "static/media/tray3.17160573.png";